








































import Vue from 'vue';

export default Vue.extend({
  name: 'Card',
  mounted() {
    this.resizeTextSize();
    window.addEventListener('resize', this.resizeTextSize);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeTextSize);
  },
  methods: {
    resizeTextSize() {
      (this.$el as HTMLElement).style.fontSize = `${0.4 * this.$el.clientHeight}px`;
    },
  },
});
